import { Api } from './Api'

const addressesPathTo = {
  get: (id) => {
    return Api.request({
      url: '/addresses/' + id + '.json',
      method: 'get',
    })
  },
  save: (data) => {
    return Api.request({
      url: '/addresses.json',
      method: 'post',
      data: { address: data}
    })
  },
  update: (id, data) => {
    return Api.request({
      url: '/addresses/' + id + '.json',
      method: 'put',
      data: { address: data }
    })
  },
  delete: (id) => {
    return Api.request({
      url: '/addresses/' + id + '.json',
      method: 'delete',
    })
  },
  list: (params) => {
    return Api.request({
      url: '/addresses.json',
      method: 'get',
      params
    })
  }

}

export default addressesPathTo